<template>
    <router-link :to="getTo()">
        <slot></slot>
    </router-link>
</template>
<script>
    export default {
        props: ["to"],
        methods: {
            getTo() {
                if (typeof this.to !== "string") {
                    return this.to
                }
                // we strip leading and trailing slashes and prefix
                // the current locale
                this.$emit("menuClicked", this.to);
                return `/${this.to.replace(/^\/|\/$/g, "")}`
            }
        }
    }
</script>